// React imports.
import React from "react";


const Assessment2aMainTable = ({step, model, fieldChangeHandler }) => (
    <div>
        <br />
        <div className="vendorsReportedGrid">
            {/*Header*/}
            <div className="header">Electric Vendor Type</div>
            <div className="header"># of Vendors Serving LIHEAP Clients</div>
            {step.showNumReq === true &&
                <div className="header"># of Electric Vendors from Whom Data was Requested</div>    
            }
            {step.showNumRec === true &&
                <div className="header"># of Electric Vendors from Whom Data was Received</div>
            }
            {(step.showVendorReceivedStatus === true || step.showVendorZeroError === true) &&
                <div className="header">Status</div>
            }


            {/*Investor-Owned Utilities (IOUs)*/}
            <div className="dwGridRow col1  row2 ">Investor-Owned Utilities (IOUs)</div>
            <div className="dwGridRow col2 yellow-background  row2  ">
                <input id="investorOwnedUtilVendorsNum" name="investorOwnedUtilVendorsNum"  value={model.investorOwnedUtilVendorsNum} 
                    onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                    className="form-control " />
            </div>
            {step.showNumReq === true &&
                <div className="dwGridRow col3 yellow-background  row2  ">
                    <input id="investorOwnedUtilRequestedVendorsNum" name="investorOwnedUtilRequestedVendorsNum" value={model.investorOwnedUtilRequestedVendorsNum} 
                        onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                        className="form-control " />
                </div>    
            }
            {step.showNumRec === true &&
                <div className="dwGridRow col4  yellow-background  row2  ">
                    <input id="investorOwnedUtilReceivedVendorsNum" name="investorOwnedUtilReceivedVendorsNum" value={model.investorOwnedUtilReceivedVendorsNum} 
                        onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                        className="form-control " />
                </div>
            }
            {step.showVendorReceivedStatus === true &&
                <div className="dwGridRow col5 center  row2 ">-</div>
            }
            {(step.showVendorZeroError === true
              &&(model.investorOwnedUtilVendorsNum === 0
                  || model.investorOwnedUtilRequestedVendorsNum > 0))
              &&
                  <div className="dwGridRow col5   green-background  row2 ">No issue.</div>
            }
            {(step.showVendorZeroError === true
              &&(model.investorOwnedUtilVendorsNum > 0
                  && model.investorOwnedUtilRequestedVendorsNum === 0))
              &&
                  <div className="dwGridRow col5   red-background   row2  ">Data not requested from any vendors.</div>
            }

            {/*Public Municipal Utilities*/}
            <div className="dwGridRow col1   row3  ">Public Municipal Utilities</div>
            <div className="dwGridRow col2 yellow-background  row3  ">
                <input id="publicMuniUtilVendorsNum" name="publicMuniUtilVendorsNum" value={model.publicMuniUtilVendorsNum} 
                    onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                    className="form-control " />
            </div>
            {step.showNumReq === true &&
                <div className="dwGridRow col3 yellow-background   row3   ">
                    <input id="publicMuniUtilRequestedVendorsNum" name="publicMuniUtilRequestedVendorsNum" value={model.publicMuniUtilRequestedVendorsNum} 
                        onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                        className="form-control " />
                </div>    
            }
            {step.showNumRec === true &&
                <div className="dwGridRow col4 yellow-background   row3  ">
                    <input id="publicMuniUtilReceivedVendorsNum" name="publicMuniUtilReceivedVendorsNum" value={model.publicMuniUtilReceivedVendorsNum} 
                        onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                        className="form-control " />
                </div>
            }
            {step.showVendorReceivedStatus === true &&
                <div className="dwGridRow col5 center   row3  ">-</div>
            }
            {(step.showVendorZeroError === true
              &&(model.publicMuniUtilVendorsNum === 0
                  || model.publicMuniUtilRequestedVendorsNum > 0))
              &&
                  <div className="dwGridRow col5 green-background  row3 ">No issue.</div>
            }
            {(step.showVendorZeroError === true
              &&(model.publicMuniUtilVendorsNum > 0
                  && model.publicMuniUtilRequestedVendorsNum === 0))
              &&
                  <div className="dwGridRow col5   red-background  row3  ">Data not requested from any vendors.</div>
            }


            {/*Rural Electric Cooperatives (Co-Ops)*/}
            <div className="dwGridRow col1   row4  ">Rural Electric Cooperatives (Co-Ops)</div>
            <div className="dwGridRow col2 yellow-background row4 ">
                <input id="ruralCoopVendorsNum" name="ruralCoopVendorsNum" value={model.ruralCoopVendorsNum} 
                    onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                    className="form-control " />
            </div>
            {step.showNumReq === true &&
                <div className="dwGridRow col3 yellow-background  row4  ">
                    <input id="ruralCoopRequestedVendorsNum" name="ruralCoopRequestedVendorsNum" value={model.ruralCoopRequestedVendorsNum} 
                        onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                        className="form-control " />
                </div>    
            }
            {step.showNumRec === true &&
                <div className="dwGridRow col4 yellow-background  row4 ">
                    <input id="ruralCoopReceivedVendorsNum" name="ruralCoopReceivedVendorsNum" value={model.ruralCoopReceivedVendorsNum} 
                        onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                        className="form-control " />
                </div>
            }
            {step.showVendorReceivedStatus === true &&
                <div className="dwGridRow col5 center row4  ">-</div>
            }
            {(step.showVendorZeroError === true
              &&(model.ruralCoopVendorsNum === 0
                  || model.ruralCoopRequestedVendorsNum > 0))
              &&
                  <div className="dwGridRow col5   green-background   row4  ">No issue.</div>
            }
            {(step.showVendorZeroError === true
              &&(model.ruralCoopVendorsNum > 0
                  && model.ruralCoopRequestedVendorsNum === 0))
              &&
                  <div className="dwGridRow col5   red-background  row4   ">Data not requested from any vendors.</div>
            }
            {/*Unknown*/}
            <div className="dwGridRow col1  row5 ">Unknown</div>
            <div className="dwGridRow col2 yellow-background   row5  ">
                <input id="unknownTypeVendorsNum" name="unknownTypeVendorsNum" value={model.unknownTypeVendorsNum} 
                    onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                    className="form-control " />
            </div>
            {step.showNumReq === true &&
                <div className="dwGridRow col3 yellow-background   row5  ">
                    <input id="unknownTypeRequestedVendorsNum" name="unknownTypeRequestedVendorsNum" value={model.unknownTypeRequestedVendorsNum} 
                        onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                        className="form-control " />
                </div>    
            }
            {step.showNumRec === true &&
                <div className="dwGridRow col4 yellow-background   row5 ">
                    <input id="unknownTypeReceivedVendorsNum" name="unknownTypeReceivedVendorsNum" value={model.unknownTypeReceivedVendorsNum} 
                        onChange={(changeEvent) => fieldChangeHandler(changeEvent, model)} 
                        className="form-control " />
                </div>
            }
            {(step.showVendorReceivedStatus === true || step.showVendorZeroError === true) &&
                <div className="dwGridRow col5 center   row5 ">-</div>
            }

            {/*Total */}
            {step.showTotal === true
            &&<React.Fragment>
                <div className="dwGridRow col1 row6 ">Total</div>
                <div className="dwGridRow col2 orange-background row6 ">
                    {model.totalNumVendors}
                </div>
                {step.showNumReq === true &&
                    <div className="dwGridRow col3  orange-background row6 ">
                        {model.totalRequestedVendors}
                    </div>
                }
                {step.showNumRec === true &&
                    <div className="dwGridRow col4  orange-background row6 ">
                        {model.totalReceivedVendors}
                    </div>
                }
                {step.showVendorReceivedStatus === true &&
                    <div className={"dwGridRow col5  row6 "  + model.statusCssString}>
                        {model.totalVendorStatusString}
                    </div>
                }
            </React.Fragment>
            }
        </div>
    </div>
);

export default Assessment2aMainTable;
